import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';

export enum TrialAddonType {
  RemoteDevelopmentEnvironments = 'remote-development-environments',
  BuildCache = 'build-cache',
  Ci = 'ci',
  BuildHub = 'build-hub-trial',
}

export enum TrialAddonStatus {
  NotStarted = 'not_started',
  CcVerificationRequired = 'cc_verification_required',
  Active = 'active',
  TrialExpired = 'trial_expired',
  Live = 'live',
}

export type AddonTrialShowResponse = {
  trialExpiresAt: string | null;
  trialStartedAt: string | null;
  status: TrialAddonStatus;
  type: TrialAddonType;
};

export const addonTrialQueryKey = (orgSlug: string, addonType: TrialAddonType) => ['addon-trial', addonType, orgSlug];

export const useAddonTrialShow = (
  orgSlug: string,
  addonType: TrialAddonType,
  options?: UseMonolithApiQueryOptions<AddonTrialShowResponse, SimpleErrorResponse>,
) => {
  return useMonolithApiQuery<AddonTrialShowResponse, SimpleErrorResponse>(
    addonTrialQueryKey(orgSlug, addonType),
    `/organizations/${orgSlug}/addon_trials/${addonType}`,
    options,
  );
};
